<template>
  <a-modal
    v-model="styleModalVisible"
    title="设置样式"
    @ok="updateStyleHandle"
    :maskClosable="false"
    cancelText="取消"
    okText="确定"
  >
    <a-row>
      <a-col :span="4">显示标签：</a-col>
      <a-col :span="6">
        <a-switch v-model="isShowLabel" />
      </a-col>
    </a-row>
    <a-row v-show="isShowLabel">
      <a-col :span="4">显示字段：</a-col>
      <a-col :span="8">
        <a-select
          style="width:100%;"
          v-model="polygonStyle.labelField"
          :options="fieldOptions"
          placeholder="请选择显示字段"
          size="small"
        >
        </a-select>
      </a-col>
      <a-col :span="2"></a-col>
      <a-col :span="4">字体大小：</a-col>
      <a-col :span="4">
        <a-input-number
          :min="0"
          :max="64"
          :step="0.5"
          size="small"
          v-model="polygonStyle.fontSize"
        />
      </a-col>
    </a-row>
    <a-row v-show="isShowLabel">
      <a-col :span="4">字体：</a-col>
      <a-col :span="8">
        <a-select
          style="width:100%;"
          v-model="polygonStyle.fontFamilary"
          placeholder="请选择字体"
          size="small"
        >
          <a-select-option value="宋体">
            宋体
          </a-select-option>
          <a-select-option value="微软雅黑">
            微软雅黑
          </a-select-option>
          <a-select-option value="黑体">
            黑体
          </a-select-option>
          <a-select-option value="楷体">
            楷体
          </a-select-option>
          <a-select-option value="仿宋">
            仿宋
          </a-select-option>
          <a-select-option value="Times New Roman">
            Times New Roman
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="2"></a-col>
      <a-col :span="4">字体颜色：</a-col>
      <a-col :span="6">
        <colorPicker v-model="polygonStyle.fontColor" />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="4">渲染方式：</a-col>
      <a-col :span="10">
        <a-select
          style="width:100%;"
          v-model="renderType"
          placeholder="请选择渲染方式"
          size="small"
          @change="renderTypeChange"
        >
          <a-select-option value="single">
            单值渲染
          </a-select-option>
          <a-select-option value="categorized">
            分类渲染
          </a-select-option>
          <a-select-option value="template">
            使用内置模板
          </a-select-option>
        </a-select>
      </a-col>
    </a-row>
    <a-row v-show="renderType=='categorized'">
      <a-col :span="4">分类字段：</a-col>
      <a-col :span="10">
        <a-select
          style="width:100%;"
          v-model="selectedField"
          :options="fieldOptions"
          placeholder="请选择字段"
          size="small"
          @change="fieldChange"
        >
        </a-select>
      </a-col>
    </a-row>
    <a-row v-show="renderType=='template'">
      <a-col :span="4">样式模板：</a-col>
      <a-col :span="10">
        <a-select
          style="width:100%;"
          v-model="selectedTemplate"
          :options="templateOptions"
          placeholder="请选择样式"
          size="small"
          @change="templateChange"
        >
        </a-select>
      </a-col>
    </a-row>
    <a-row v-show="renderType=='template'">
      <a-col :span="24">
        <img :src="legendSrc" />
      </a-col>
    </a-row>
    <a-row v-show="renderType!='template'">
      <a-col :span="4">边框颜色：</a-col>
      <a-col :span="6">
        <colorPicker v-model="polygonStyle.symbolStrokeColor" />
      </a-col>
      <a-col :span="4"></a-col>
      <a-col :span="4">边框宽度：</a-col>
      <a-col :span="6">
        <a-input-number
          :min="0"
          :max="10"
          :step="0.1"
          size="small"
          v-model="polygonStyle.symbolStrokeWidth"
        />
      </a-col>
    </a-row>
    <a-row v-show="renderType=='categorized'">
      <a-col :span="4">颜色梯度：</a-col>
      <a-col :span="10">
        <a-select
          style="width:100%;"
          placeholder="请选择颜色梯度"
          size="small"
          @change="rMapChange"
          v-model="selectedRMapValue"
        >
          <a-select-option
            v-for="i in 10"
            :key="i"
          >
            <div :class="'dd-color-rmap-'+(i-1)"></div>
          </a-select-option>
        </a-select>
      </a-col>
    </a-row>
    <a-row v-show="renderType=='categorized'">
      <a-col :span="24">
        <a-list
          bordered
          :data-source="colorMap"
        >
          <a-list-item
            slot="renderItem"
            slot-scope="item"
          >
            <a-row style="width:100%;">
              <a-col
                :span="12"
                :title="item.val"
                style="overflow: hidden; text-overflow: ellipsis;white-space: nowrap;"
              >
                {{ item.val }}
              </a-col>
              <a-col
                :span="12"
                style="height:20px;"
              >
                <colorPicker
                  class="dd-color-picker"
                  v-model="item.color"
                />
              </a-col>
            </a-row>
          </a-list-item>
        </a-list>
      </a-col>
    </a-row>
    <a-row v-show="renderType=='single'">
      <a-col :span="4">填充颜色：</a-col>
      <a-col :span="6">
        <colorPicker v-model="polygonStyle.symbolFillColor" />
      </a-col>
      <a-col :span="4"></a-col>
      <a-col :span="4">透明度：</a-col>
      <a-col :span="6">
        <a-input-number
          :min="0"
          :max="1"
          size="small"
          :step="0.1"
          v-model="polygonStyle.symbolFillOpacity"
        />
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { WFS, GeoJSON } from 'ol/format';

export default {
  name: "StyleSetting",
  data() {
    return {
      isShowLabel: false,
      currentLayerKey: "",
      styleModalVisible: false,
      renderType: "single",
      selectedField: "",
      fieldOptions: [],
      featuresData: [],
      selectedFieldValues: [],
      selectedTemplate: undefined,
      templateOptions: [],
      selectedRMapValue: undefined,
      rMap: [
        ["f7fbff", "08306b"],
        ["08306b", "f7fbff"],
        ["edf8fb", "006d2c"],
        ["006d2c", "edf8fb"],
        ["000004", "fcffa4"],
        ["fcffa4", "000004"],
        ["ffffd4", "993404"],
        ["993404", "ffffd4"],
        ["fcfbfd", "3f007d"],
        ["3f007d", "fcfbfd"]
      ],
      colorMap: [],
      polygonStyle: {
        symbolStrokeColor: "",
        symbolStrokeWidth: 0,
        symbolFillColor: "",
        symbolFillOpacity: 1,
        layer: "",
        fontSize: 12,
        fontFamilary: "宋体",
        fontColor: "#000",
        labelField: ""
      },
      legendSrc: ""
    }
  },
  methods: {
    templateChange(val) {
      this.legendSrc = `${process.env.VUE_APP_GEOSERVER_ROOT}wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&LAYER=chs:${this.currentLayerKey}&style=chs:${val}`;
    },
    rMapChange(val) {
      if (this.selectedFieldValues.length == 0) {
        if (this.selectedField && this.featuresData.length > 0) {
          let tempVals = new Set();
          this.featuresData.forEach(feature => {
            tempVals.add(feature.get(this.selectedField));
          })
          this.selectedFieldValues = Array.from(tempVals).sort();
        } else {
          this.$message.warn("请先选择一个分类字段");
          return;
        }
      }
      const colorRange = this.rMap[val - 1];
      const colorArray = this.gradientColor(colorRange[0], colorRange[1], this.selectedFieldValues.length);
      this.colorMap = this.selectedFieldValues.map((val, index) => {
        return { val: val, color: '#' + colorArray[index] };
      })
    },
    fieldChange(val) {
      let tempVals = new Set();
      this.featuresData.forEach(feature => {
        tempVals.add(feature.get(val));
      })
      this.selectedFieldValues = Array.from(tempVals).sort();

      if (this.selectedRMapValue > 0) {
        const colorRange = this.rMap[this.selectedRMapValue - 1];
        const colorArray = this.gradientColor(colorRange[0], colorRange[1], this.selectedFieldValues.length);
        this.colorMap = this.selectedFieldValues.map((val, index) => {
          return { val: val, color: '#' + colorArray[index] };
        })
      }
    },
    renderTypeChange(val) {

    },
    getCurrentStyle(record) {
      this.$httpGet(`/zserver/api/get_style/${record.layer}`).then(res => {
        this.styleModalVisible = true;
        const styleContent = res.data;
        if (styleContent.render_type == "template") {
          this.renderType = "template";
          this.selectedTemplate = styleContent.style_content;
          this.legendSrc = `${process.env.VUE_APP_GEOSERVER_ROOT}wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&LAYER=chs:${this.currentLayerKey}&style=chs:${this.selectedTemplate}`;
        } else if (styleContent.render_type == "categorized") {
          this.renderType = "categorized";
          const rules = JSON.parse(styleContent.style_content);
          const fillRules = rules.filter(rule => !rule["labelField"]);
          const labelRules = rules.filter(rule => rule["labelField"]);
          this.colorMap = [];
          fillRules.forEach((rule, idx) => {
            if (idx == 0) {
              this.rMap.forEach((rm, idxRm) => {
                if ("#" + rm[0] == rule.symbolFillColor) {
                  this.selectedRMapValue = idxRm + 1;
                }
                this.polygonStyle.symbolStrokeColor = rule.symbolStrokeColor;
                this.polygonStyle.symbolStrokeWidth = rule.symbolStrokeWidth;
              });
              this.selectedField = rule.filterProperty;
            }
            this.colorMap.push({ val: rule.filterValue, color: rule.symbolFillColor });
          })
          if (labelRules.length > 0) {
            this.isShowLabel = true;
            this.polygonStyle.fontSize = labelRules[0].fontSize;
            this.polygonStyle.fontColor = labelRules[0].fontColor;
            this.polygonStyle.fontFamilary = labelRules[0].fontFamilary;
            this.polygonStyle.labelField = labelRules[0].labelField;
          } else {
            this.isShowLabel = false;
          }
        } else {
          this.renderType = "single";
          if (styleContent.style_content) {
            const rules = JSON.parse(styleContent.style_content);
            const fillRules = rules.filter(rule => !rule["labelField"]);
            const labelRules = rules.filter(rule => rule["labelField"]);
            this.polygonStyle = fillRules[0];
            if (labelRules.length > 0) {
              this.isShowLabel = true;
              this.polygonStyle.fontSize = labelRules[0].fontSize;
              this.polygonStyle.fontColor = labelRules[0].fontColor;
              this.polygonStyle.fontFamilary = labelRules[0].fontFamilary;
              this.polygonStyle.labelField = labelRules[0].labelField;
            } else {
              this.isShowLabel = false;
            }
          }
        }
        this.polygonStyle.layer = record.layer;
      })
    },
    getFeatureData(layer) {
      const featureRequest = new WFS().writeGetFeature({
        srsName: "EPSG:990000",
        featureNS: "zhc",
        featurePrefix: "zhc",
        featureTypes: [layer],
        outputFormat: "application/json"
      });
      this.$httpPost(process.env.VUE_APP_GEOSERVER_ROOT + "wfs", new XMLSerializer().serializeToString(featureRequest), { "Content-Type": "text/plain;charset=UTF-8" }).then(res => {
        const features = new GeoJSON().readFeatures(res.data)
        const firstFeature = features[0];
        const properties = firstFeature.getProperties();
        this.fieldOptions = Object.keys(properties).filter(key => key != "geometry").map(key => {
          return { label: key, value: key };
        })
        this.featuresData = features;
      })
    },
    getStyleTemplate() {
      this.$httpGet(`/zserver/api/dicts?enNo=001`).then(res => {
        if (res.data) {
          this.templateOptions = res.data.map(dict => {
            return { label: dict.ch_name, value: dict.en_name };
          });
        }
      })
    },
    updateStyleHandle() {
      let rules = [];
      let labelRule = {};
      let content = "";
      if (this.renderType == "single") {
        let rule = this.polygonStyle;
        rule.styleName = rule.layer;
        rules.push(rule);
        if (this.isShowLabel && this.polygonStyle.labelField) {
          labelRule["fontSize"] = this.polygonStyle.fontSize;
          labelRule["fontFamilary"] = this.polygonStyle.fontFamilary;
          labelRule["fontColor"] = this.polygonStyle.fontColor;
          labelRule["labelField"] = this.polygonStyle.labelField;
        }
      } else if (this.renderType == "categorized") {
        if (!this.selectedField || !this.selectedRMapValue) {
          this.$message.warn("请选择分类字段和颜色梯度");
          return;
        }
        this.colorMap.forEach(colorm => {
          rules.push({
            filterProperty: this.selectedField,
            filterValue: colorm.val,
            filterCondition: "=",
            symbolFillColor: colorm.color,
            symbolFillOpacity: 1,
            symbolStrokeColor: this.polygonStyle.symbolStrokeColor,
            symbolStrokeWidth: this.polygonStyle.symbolStrokeWidth,
            symbolStrokeOpacity: 1
          });
        })
        if (this.isShowLabel && this.polygonStyle.labelField) {
          labelRule["fontSize"] = this.polygonStyle.fontSize;
          labelRule["fontFamilary"] = this.polygonStyle.fontFamilary;
          labelRule["fontColor"] = this.polygonStyle.fontColor;
          labelRule["labelField"] = this.polygonStyle.labelField;
        }
      } else if (this.renderType == "template") {
        content = this.selectedTemplate;
      }
      this.$httpPost("/zserver/api/update_style", { styleName: this.polygonStyle.layer, styleContent: content, rules: rules, render_type: this.renderType, labelRule: labelRule }).then(res => {
        this.styleModalVisible = false;
        if (res.data) {
          this.$message.success("更新样式成功", 2);
          this.$emit("okClose", this.polygonStyle.layer);
        }
      })
    },
    gradientColor(f, t, n) {
      return [...Array(++n + 1)].map((_, i) => f.replace(/../g, (e, j) => ((`0x${e}` * (n - i) + `0x${t[j] + t[j + 1]}` * i) / n | 256).toString(16).slice(1)));
    },
  },
  mounted() {
    this.currentLayerKey = "";
    this.$nextTick(() => {
      this.$on("showThis", (layerInfo) => {
        this.currentLayerKey = layerInfo.layer;
        this.getCurrentStyle(layerInfo);
        this.getFeatureData(layerInfo.layer);
        this.getStyleTemplate();
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.ant-row {
  margin-top: 0.5rem;
}
.dd-color-rmap {
  min-width: 150px;
  width: 100%;
  height: 20px;
}
.dd-color-rmap-0 {
  @extend .dd-color-rmap;
  background: linear-gradient(to right, #f7fbff, #08306b);
}
.dd-color-rmap-1 {
  @extend .dd-color-rmap;
  background: linear-gradient(to left, #f7fbff, #08306b);
}
.dd-color-rmap-2 {
  background: linear-gradient(to right, #edf8fb, #006d2c);
  @extend .dd-color-rmap;
}
.dd-color-rmap-3 {
  background: linear-gradient(to left, #edf8fb, #006d2c);
  @extend .dd-color-rmap;
}
.dd-color-rmap-4 {
  background: linear-gradient(to right, #000004, #fcffa4);
  @extend .dd-color-rmap;
}
.dd-color-rmap-5 {
  background: linear-gradient(to left, #000004, #fcffa4);
  @extend .dd-color-rmap;
}
.dd-color-rmap-6 {
  background: linear-gradient(to right, #ffffd4, #993404);
  @extend .dd-color-rmap;
}
.dd-color-rmap-7 {
  background: linear-gradient(to left, #ffffd4, #993404);
  @extend .dd-color-rmap;
}
.dd-color-rmap-8 {
  background: linear-gradient(to left, #fcfbfd, #3f007d);
  @extend .dd-color-rmap;
}
.dd-color-rmap-9 {
  background: linear-gradient(to right, #fcfbfd, #3f007d);
  @extend .dd-color-rmap;
}
</style>
<style lang="scss">
.ant-list-items {
  padding: 0px 5px;
  & .ant-list-item {
    padding: 5px;
    height: 30px;
  }
}
.dd-color-picker {
  width: 100%;
  height: 100%;
  & .colorBtn {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>